import { useLocation, useNavigate, useParams } from 'react-router-dom';
import React from 'react';
export const withRouter = (Component) => {
    const Wrapper = (props) => {
        const navigate = useNavigate();
        return <Component location={useLocation()} params={useParams()} navigate={navigate} {...props}/>;
    };
    return Wrapper;
};
